/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import DbBaseObject from '@shared/DbBaseObject.js';
import {Type} from "class-transformer";
import BillingItem from "@/core/js/model/Billing/BillingItem";
import Discriminator from "@/utils/Discriminator";
import RecurringBillingItem from "@shared/Billing/RecurringBillingItem";

export const BillingType = Object.freeze({
	HOURLY: 'HOURLY',
	FIXED: 'FIXED',
	RECURRING: 'RECURRING',
})


export default class BillingData extends DbBaseObject {

	minPaidDateTs: number = 0
	maxPaidDateTs: number = 0
	programId: string = ""

	hourlyRate: number = 0

	billingType: BillingType = BillingType.RECURRING


	@Type(() => BillingItem, Discriminator.create([
		{ value: BillingItem, name: "BillingItem" },
		{ value: RecurringBillingItem, name: "RecurringBillingItem" },
	]))
	billingItems: BillingItem[] = []


	constructor() {
		super();
	}

	// setupRecurringBillingItemIfNeeded(){
	// 	let res = this.billingItems.filter(item => item.billingType === BillingType.RECURRING)
	// 	let billingItem
	// 	if(res.length === 0){
	// 		let recurringBillingItem = new RecurringBillingItem()
	// 		this.billingItems.push(recurringBillingItem)
	// 		billingItem = recurringBillingItem
	// 	} else {
	// 		billingItem = res[0]
	// 	}
	// 	return billingItem
	// }

	totalAmount() {
		let res = this.billingItems.reduce((sum, billingItem) => sum + Number(billingItem.amount), 0)
		return Math.max(0, res);
	}

	numberOfMilestones() {
		let res = this.billingItems.reduce((sum, billingItem) => sum + (billingItem.isFixed() ? 1 : 0), 0)
		return res;
	}

	totalAmountPaid(billingItemGroupArray) {
		let paid = this.paidItems(billingItemGroupArray)
		console.log("totalAmountPaid: ", billingItemGroupArray)
		console.log("totalAmountPaid: paid = ", paid)
		console.log("totalAmountPaid: this = ", this)
		let res = paid.reduce((sum, billingItem) => sum + Number(billingItem.amount), 0)
		return res;
	}

	// getRecurringBillingItem(){
	// 	return this.setupRecurringBillingItemIfNeeded()
	// }

	setRecurringBillingItem(recurringBillingItem){
		return this.setBillingItem(recurringBillingItem)
	}


	invalidate(invoiceGroupArray) {
		this.calculatePaidDateRange(invoiceGroupArray)
		this.syncBillableHoursWithHourlyRate(invoiceGroupArray)
	}

	editableItems(invoiceGroupArray) {
		let items = this.billingItems
			.filter(billingItem => !invoiceGroupArray.find(invoiceGroup => invoiceGroup.findInvoiceByBillingItemId(billingItem.id)))
		return items
	}

	paidItems(invoiceGroupArray) {
		let items = this.billingItems
			.filter(billingItem => {
				return invoiceGroupArray.find(invoiceGroup => {
					let invoice = invoiceGroup.findInvoiceByBillingItemId(billingItem.id)
					// console.log("paidItems: invoice = ", invoice)
					if (invoice) {
						console.log("paidItems: invoice.isPaid() = ", invoice.isPaid())
					}
					return invoice ? invoice.isPaid() : false
				})
			})
		console.log("paidItems: items = ", items)
		return items
	}

	invoiceableItems(invoiceGroupArray) {
		let items = this.editableItems(invoiceGroupArray)
			.filter(billingItem => billingItem.amount > 0)
		return items
	}

	filterBillingItems(paymentStatus) {
		let res = this.billingItems.filter(item => item.paymentStatus == paymentStatus)
		return res
	}

	syncBillableHoursWithHourlyRate(invoiceGroupArray) {
		this.editableItems(invoiceGroupArray)
			.filter(item => item.isHourly)
			.forEach(item => {
				item.amount = Math.floor(item.durationMs / (60 * 60 * 1000) * this.hourlyRate)
			})
	}

	calculatePaidDateRange(invoiceGroupArray) {
		let minPaidDateTs = 9999999999999;
		let maxPaidDateTs = 0
		this.paidItems(invoiceGroupArray)
			.forEach(item => {
				if (item.paidDateTs < minPaidDateTs) {
					minPaidDateTs = item.paidDateTs;
				}
				if (item.paidDateTs > maxPaidDateTs) {
					maxPaidDateTs = item.paidDateTs;
				}
			})
		this.minPaidDateTs = minPaidDateTs;
		this.maxPaidDateTs = maxPaidDateTs;
	}

	findBillingItemById(itemId) {
		if(itemId){
			return this.billingItems.find(item => item.id === itemId)
		}
	}

	findBillingItemByMilestoneSectionId(milestoneSectionId) {
		return this.billingItems.find(item => item.milestoneSectionId === milestoneSectionId)
	}


	findBillingItemIndexById(itemId) {
		let itemIndex = this.billingItems.map(item => item.id).indexOf(itemId);
		return itemIndex
	}

	removeBillingItemById(itemId) {
		let index = this.findBillingItemIndexById(itemId)
		return ~index && this.billingItems.splice(index, 1);
	}

	setBillingItem(billingItem) {
		let index = this.findBillingItemIndexById(billingItem.id)
		if(index >= 0){
			this.billingItems[index] = billingItem;
			return true
		}
		return false
	}

	isFixed() {
		return this.billingType === BillingType.FIXED
	}

	isRecurring() {
		return this.billingType === BillingType.RECURRING
	}

	get isHourly() {
		return this.billingType === BillingType.HOURLY
	}

	set isHourly(val) {
		if (val) {
			this.billingType = BillingType.HOURLY
		} else {
			this.billingType = BillingType.FIXED
		}
	}

	billingItemsByType() {
		return this.billingItems.filter(item => item.billingType == this.billingType)
	}


}



